import React,{useState} from 'react';
import { Card, CardBody, CardHeader } from 'react-bootstrap';
import { PiTicket } from "react-icons/pi";
import { MdOutlineModeEdit } from "react-icons/md"; 
import  './style.css'
import { CardFooter } from 'reactstrap';
const PreviousTicketCard = ({ data ,handleEdit,itmode,toggle}) => {
  const [viewstatus, setviewstatus] = useState(false);  
  return (
    <Card style={{ borderRadius: '24px', }}>
     <div style={{maxHeight:viewstatus?'':'300px',overflow:'hidden'}}>
     <CardHeader style={{ borderRadius: '24px 24px 0px 0px' }}>
        <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>

          {/* child 1 */}
          <div className='d-flex align-items-center flex-wrap gap-2'>
            <PiTicket className='p-1' style={{ width: '30px', height: '30px', color: '#175FA4', background: '#E8EFF6', borderRadius: '50%' }} />
            <span className='ms-2' style={{ color: '#555555' }}>Ticket# {data?.id} {data?.factory?.name || null}</span>
            {data?.status=='pending'? 
            <span className='ms-2 p-1' style={{ background: '#F7F8F9', borderRadius: '4px', color: 'black' }}>{data?.status}</span>
              :data?.status=='in process'?
            <span className='ms-2 p-1' style={{ background: '#FFF7E6', borderRadius: '4px', color: '#D99104D9' }}>{data?.status}</span>
            :data?.status=='resolved'?
            <span className='ms-2 p-1' style={{ background: '#EEF8ED', borderRadius: '4px', color: '#43953B' }}>{data?.status}</span>
            :'Pending'}
          </div>

          {/* child 2 */}
          {itmode==true?<>
          { data?.status =='resolved'?null:
            <button style={{ outline: 'none', border: '1px solid #175FA4', color: '#175FA4D9', background: 'none', fontSize: '14px', borderTop: '0px', borderInline: '0px' }} onClick={toggle}>
            Update
            <MdOutlineModeEdit className='ms-2' style={{ color: '#175FA4' }} />
          </button>
          }
          </>:<>
          <div>
            <button style={{ outline: 'none', border: '1px solid #175FA4', color: '#175FA4D9', background: 'none', fontSize: '14px', borderTop: '0px', borderInline: '0px' }} onClick={handleEdit}>
              Edit
              <MdOutlineModeEdit className='ms-2' style={{ color: '#175FA4' }} />
            </button>
          </div>
          
          {/* {
            data && data.status =='pending'? <div>
            <button style={{ outline: 'none', border: '1px solid #175FA4', color: '#175FA4D9', background: 'none', fontSize: '14px', borderTop: '0px', borderInline: '0px' }} onClick={handleEdit}>
              Edit
              <MdOutlineModeEdit className='ms-2' style={{ color: '#175FA4' }} />
            </button>
          </div>
          :null
          } */}
          </>}
          
        </div>
      </CardHeader>

      <CardBody >
        <p className='mb-1' style={{ color: '#555555', fontSize: '14px', fontWeight: '500' }}>Details:</p>

        {/* Render Modules */}
        <p className='mb-1 new_ticket_card_details' >
          Module: 
          {data?.models?.map((mod, index) => (
            <span className='p-1 mx-2 moduleSubHeading' style={{background:'#E9F6FC',borderRadius:'4px',color:'#1E84B0'}} key={mod.id}>{mod.name}</span>
          ))}
        </p>

        <p className='mb-1 new_ticket_card_details' >Generated by: {data?.owner}</p>
        <p className='mb-1 new_ticket_card_details' >Issue Date: {data?.ticketDate  }</p>
        {data && data.status !='pending'? <p className='mb-1 new_ticket_card_details' >Response Date: {data?.responseDate}</p>:null}

        <hr style={{ border: '1px dashed' }} />

        {/* Render Areas */}
        <p className='mb-1 new_ticket_card_details' >
          Area:
          {data?.areas?.map((a, index) => (
            <span key={a.id}>{a.name}{index < data.areas.length - 1 ? ', ' : ''}</span>
          ))}
        </p>

        {/* Render Sub Areas */}
        <p className='mb-1 new_ticket_card_details' >
          Sub Area:
          {data?.sub_areas?.map((sub, index) => (
            <span key={sub.id}>{sub.name}{index < data.sub_areas.length - 1 ? ', ' : ''}</span>
          ))}
        </p>

        <hr style={{ border: '1px dashed' }} />

        <p className='mb-1 new_ticket_card_details' >Priority: {data?.priority}</p>

        <hr style={{ border: '1px dashed' }} />

        <p className='mb-1' style={{ color: '#555555', fontSize: '14px', fontWeight: '500' }}>Query:</p>
        <p>{data?.query}</p>

        {data && data.status !=='pending'?<>
          <p className='mb-1' style={{ color: '#555555', fontSize: '14px', fontWeight: '500',fontStyle:'italic' }}>Response:</p>
          <p>{data?.response}</p>
        </> :null}
      </CardBody>
     </div>
      <CardFooter className='d-flex justify-content-end'>
        <button style={{border:'0px',borderRadius:'0px',borderBottom:'1px solid #175FA4',color:'#175FA4',background:'none'}} onClick={()=>setviewstatus(!viewstatus)}>
          {viewstatus?'View less':'View more'} 
          </button>
      </CardFooter>
    </Card>
  );
};

export default PreviousTicketCard;
